<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :deleteAction="data._id ? data.can_delete ? deleteAction : false : false"
        :id="id"
        :actionButtons="!hideForm"
        size="md"
        :closeButton="hideForm"
        @shown="shown"
    >
        <b-form-group :label="$t('Leave a comment')">
            <b-form-textarea
                id="textarea"
                :placeholder="$t('Cancellation reason. Ex.: Wrong payment')"
                rows="3"
                v-model="data.cancelExplanation"
            ></b-form-textarea>
        </b-form-group>
    </modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Modal from "@/components/Modal.vue";

export default {
    name: 'transactions-cancel-modal',
    props: ['id'],
    components: {
        Modal
    },
    data() {
        return {
            hideForm: false,
            title: 'Payment cancellation',
            errors: {},
            data: {},

        }
    },
    mounted() {

    },

    methods: {
        ...mapActions('transactions', ['create', 'patch']),
        shown() {
            this.errors = {};
            this.data = {};
            const { Transaction } = this.$FeathersVuex;
            let data = Transaction.getFromStore('temp');
            if (data) {
                delete data._id;
                this.data = JSON.parse(JSON.stringify(data['model']));
                new Transaction({
                    model: {},
                    _id: 'temp'
                });
            }
            //console.log(this.data);
        },
        saveAction() {
            let promise, successMessage;

            let patchData = {
                cancelExplanation: this.data.cancelExplanation,
                cancelled: true,
                invoiceId: this.data.invoiceId,
            };

            if (this.data._id) {
                promise = this.patch([this.data._id, patchData]);
                successMessage = this.$t('Payment cancelled');
            }

            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });

            promise.catch(err => {
                this.errors = err.errors;
                this.$toasted.show(err.message, {
                    theme: "bubble",
                    position: "top-right",
                    duration: 3000
                });
            });
        },

        validation(field) {

            if (this.errors && this.errors[field])
                return false;
            else
                return null
        },

    },

}
</script>
